module.exports = __webpack_public_path__ + "12f2789cbb2d84f1e9e5b6381a9f756e.MP3";